export class StoreViewModel {
  public itemsPerPage = 25;
  public headers = [
    { text: "Bezeichnung", value: "name" },
    { text: "Mitarbeiter", value: "employee.lastname" },
    { text: "", value: "actions", align: "right" }
  ];
  public items: any[] = [];
  public totalItems = 0;
  public options = {
    groupBy: [],
    groupDesc: [],
    itemsPerPage: this.itemsPerPage,
    multiSort: true,
    mustSort: false,
    sortBy: ["name"],
    sortDesc: [false]
  };
  public loading = true;
  public pageNumber = 1;
  public search = "";
}
